import { BloodPressureBadge } from 'components/Calendar/BloodPressureBadge';
import { Calendar } from 'components/Calendar/Calendar';
import { Legend } from 'components/Charts/Legend';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { usePatientDetailContext } from 'context/hooks';
import { useBloodPressureOverview } from 'hooks/api/bloodpressure/useBloodPressureData';
import { useGetBloodPressureClassification } from 'hooks/api/bloodpressure/useGetBloodPressureClassification';
import { t } from 'i18next';
import { BloodPressureGuidelinesKeys, getBloodPressureClassificationColor } from 'utils/measurements/bloodpressure';

export const BloodPressureCalendar = () => {
  const { data, getItemById, isLoading, handleSelected } = useBloodPressureOverview();
  const { data: bloodPressureClassification } = useGetBloodPressureClassification();
  const { startDate, endDate } = usePatientDetailContext();

  const items =
    bloodPressureClassification?.data.guideLineKey === BloodPressureGuidelinesKeys.ESC_2018 // Groups the high graded severity together and no weight yet is available for the ESC_2018 so the legend is build custom, from ESC_2024 a more generic map aproach is used
      ? [
          { color: 'var(--mantine-color-red-5)', title: t('severity_high_grade') },
          { color: 'var(--mantine-color-peach-7)', title: t('severity_high_normal') },
          { color: 'var(--mantine-color-turquoise-5)', title: t('severity_normal') },
        ]
      : [...(bloodPressureClassification?.data?.classifications ?? [])]
          .sort((a, b) => (a.weight ?? 0) + (b.weight ?? 0))
          .map((classification) => ({
            color: getBloodPressureClassificationColor(classification.color),
            title: t(`severity_${classification.label}`),
          }));

  return (
    <PaperWithBorder title={t('patients_calendar_title')} isLoading={isLoading} testId={'blood-pressure-calendar'}>
      <Legend
        items={[
          ...items,
          {
            color: 'var(--mantine-color-black)',
            title: t('severity_symptoms_present'),
            innerColor: 'var(--mantine-color-gray-3)',
          },
        ]}
      />
      <Calendar
        range={{
          startDate,
          endDate,
        }}
        events={data.map((item) => ({
          id: item.id,
          date: item.date,
          value: item.bloodPressure,
        }))}
        renderItem={(calendarItem) => (
          <BloodPressureBadge
            key={calendarItem.id}
            item={getItemById(calendarItem.id)}
            onClick={(id) => handleSelected(getItemById(id))}
          />
        )}
      />
    </PaperWithBorder>
  );
};
